"use client";
import { jsxs as n, jsx as r } from "react/jsx-runtime";
const f = ({
  title: l,
  titleId: a,
  desc: e,
  descId: i,
  ...t
}) => /* @__PURE__ */ n(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-hk",
    viewBox: "0 0 640 480",
    "aria-labelledby": a,
    "aria-describedby": i,
    ...t,
    children: [
      e ? /* @__PURE__ */ r("desc", { id: i, children: e }) : null,
      l ? /* @__PURE__ */ r("title", { id: a, children: l }) : null,
      /* @__PURE__ */ r("path", { fill: "#EC1B2E", d: "M0 0h640v480H0" }),
      /* @__PURE__ */ r(
        "path",
        {
          id: "hk-a",
          fill: "#fff",
          d: "M346.3 103.1C267 98 230.6 201.9 305.6 240.3c-26-22.4-20.6-55.3-10.1-72.4l1.9 1.1c-13.8 23.5-11.2 52.7 11.1 71-12.7-12.3-9.5-39 12.1-48.9s23.6-39.3 16.4-49.1q-14.7-25.6 9.3-38.9M307.9 164l-4.7 7.4-1.8-8.6-8.6-2.3 7.8-4.3-.6-8.9 6.5 6.1 8.3-3.3-3.7 8.1 5.6 6.8z"
        }
      ),
      /* @__PURE__ */ r("use", { xlinkHref: "#hk-a", transform: "rotate(72 312.5 243.5)" }),
      /* @__PURE__ */ r("use", { xlinkHref: "#hk-a", transform: "rotate(144 312.5 243.5)" }),
      /* @__PURE__ */ r("use", { xlinkHref: "#hk-a", transform: "rotate(216 312.5 243.5)" }),
      /* @__PURE__ */ r("use", { xlinkHref: "#hk-a", transform: "rotate(288 312.5 243.5)" })
    ]
  }
);
export {
  f as default
};
